import React from "react";

interface IProps {
	className?: string;
	color: string;
}

export const Semester = ({ className, color }: IProps) => {
	return (
		<svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0)">
				<path
					d="M6.75 17.25H2.25C1.85218 17.25 1.47064 17.092 1.18934 16.8107C0.908035 16.5294 0.75 16.1478 0.75 15.75V3.75C0.75 3.35218 0.908035 2.97064 1.18934 2.68934C1.47064 2.40804 1.85218 2.25 2.25 2.25H15.75C16.1478 2.25 16.5294 2.40804 16.8107 2.68934C17.092 2.97064 17.25 3.35218 17.25 3.75V11.25"
					stroke={color ?? "#A6A1A1"}
					strokeWidth="2.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path d="M0.75 6.75H17.25" stroke={color ?? "#A6A1A1"} strokeWidth="2.2" strokeLinejoin="round" />
				<path d="M5.25 3.75V0.75" stroke={color ?? "#A6A1A1"} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
				<path d="M12.75 3.75V0.75" stroke={color ?? "#A6A1A1"} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M16.5 14.308L9.75 17.087L16.5 19.558L23.25 17.087L16.5 14.308Z"
					stroke={color ?? "#A6A1A1"}
					strokeWidth="2.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path d="M9.75 17.087V20.837" stroke={color ?? "#A6A1A1"} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
				<path
					d="M12.75 18.186V21.3C12.7494 21.4505 12.7939 21.5976 12.8779 21.7224C12.9619 21.8472 13.0814 21.9439 13.221 22L16.221 23.2C16.4002 23.271 16.5998 23.271 16.779 23.2L19.779 22C19.9186 21.9439 20.0381 21.8472 20.1221 21.7224C20.2061 21.5976 20.2506 21.4505 20.25 21.3V18.186"
					stroke={color ?? "#A6A1A1"}
					strokeWidth="2.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};
